import { useEffect } from "react";
import { useSnackbar } from "notistack";
import * as serviceWorkerRegistration from "../../serviceWorkerRegistration";

export const SwUpdateSnackbar = () => {
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        const handler = (event) => {
            const registration = event.detail.registration;

            enqueueSnackbar("Nueva versión disponible", {
                variant: "info",
                persist: true,
                action: (key) => (
                    <button
                        style={{
                            border: "none",
                            background: "#1976d2",
                            color: "#fff",
                            padding: "5px 10px",
                            borderRadius: 4,
                            cursor: "pointer"
                        }}
                        onClick={() => {
                            closeSnackbar(key);
                            serviceWorkerRegistration.applyUpdate(registration);
                        }}
                    >
                        Actualizar
                    </button>
                )
            });
        };

        window.addEventListener("swUpdated", handler);

        return () => window.removeEventListener("swUpdated", handler);
    }, [enqueueSnackbar, closeSnackbar]);
    return null;
}
